import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { flatten } from 'lodash'
import { MFilters } from 'types/filterTypes'

const useSelectedOptionsCount = ({
  contentName,
  heroFilter,
  filters
}: {
  contentName: MFilters.ContentTypes
  heroFilter?: string
  filters?: string[]
}): number => {
  const filterKey: MFilters.FilterKey = `filter-${contentName}`
  const settings = useSelector((state: MStore.RootState) => state.settings)
  const savedOptions = useMemo(() => {
    return settings[filterKey] || {}
  }, [settings, filterKey])

  const heroFilterCount = heroFilter ? savedOptions?.[heroFilter]?.length : 0
  const filtersButtonCount = useMemo(() => {
    const advancedFilterOptions =
      filters && savedOptions
        ? Object.keys(savedOptions)
            .filter(key => [...filters, 'others'].includes(key))
            .reduce((obj, key) => {
              obj[key] = savedOptions[key]
              return obj
            }, {})
        : {}
    return savedOptions ? flatten(Object.values(advancedFilterOptions)).length : 0
  }, [filters, savedOptions])

  const count = heroFilterCount || filtersButtonCount || 0

  return count
}

export default useSelectedOptionsCount
